import React, { FC, useEffect, useState } from 'react';
import './NumberEntryView.css';

interface NumberEntryViewProps {
  onReturnClick: () => void
  valueToUpdate: (value: number) => void
  maxEntry?: number

}
const buttonClasses = ["one","two","three","four","five","six","seven","eight","nine","backspace","zero","enter"]
const stringToNumber = (numString: string): number => {
  switch (numString) {
    case "one":
      return 1
    case "two":
      return 2
    case "three":
      return 3
    case "four":
      return 4
    case "five":
      return 5
    case "six":
      return 6
    case "seven":
      return 7
    case "eight":
      return 8
    case "nine":
      return 9
    case "zero":
      return 0
    default:
      return 0
  }
}

const NumberEntryView: FC<NumberEntryViewProps> = ({onReturnClick, valueToUpdate, maxEntry}:NumberEntryViewProps) => {
  const [value, setValue] = useState("0")
  const [max, setMax] = useState<number>(maxEntry ?? 0)
  
  useEffect(() => {
    if (maxEntry !== max) {
      setMax(maxEntry ?? 0)
      setValue(() => {
        valueToUpdate(0)
        return "0"
      })
    }
  }, [maxEntry, max, valueToUpdate])

  const buttons = buttonClasses.map((c, index) => {
    var classes = c
    if (value === "0" && (c === "backspace" || c === "zero" || c === "enter")) {
      classes = classes + " disabled"
    } else if (maxEntry && c !== "backspace" && c !== "enter") {
      var maxEntryNumbers = maxEntry.toString()
      var thisButtonNumber = stringToNumber(c)
      var currentNumbers = value.split('')
      const potentialNewValue = Number(value + `${thisButtonNumber}`)
      if (value === "0" && thisButtonNumber > maxEntry) {
        classes = classes + " disabled"
      } else if (potentialNewValue > maxEntry) {
        classes = classes + " disabled"
      } else if (currentNumbers.length === maxEntryNumbers.length) {
        classes = classes + " disabled"
      }
    } 
    return (
      <div key={index} onClick={() => buttonClicked(c)} className={`button ${classes}`}></div>
    )
  })
  
  const buttonClicked = (item: string) => {
    switch (item) {
      case "one":
      case "two":
      case "three":
      case "four":
      case "five":
      case "six":
      case "seven":
      case "eight":
      case "nine":
      case "zero":
        setValue((prevValue) => {
          var newValue = prevValue + `${stringToNumber(item)}`
          if (prevValue === "0") {
            newValue = `${stringToNumber(item)}`
          }
          valueToUpdate(Number(newValue))
          return newValue
        })
        break
      case "enter":
        onReturnClick()
        break
      case "backspace":
        setValue((prevValue) => {
          var newValue = "0"
          if (prevValue.length > 1) {
            newValue = prevValue.substring(0, prevValue.length - 1)
          }
          valueToUpdate(Number(newValue))
          return newValue
        })
        break
      default:
        break
    }
  }

  return (
    <div className="NumberEntryView">
      <div className="entry-field">{value === "0" ? '' : value}</div>
      <div className="buttons-container">
        {buttons}
      </div>
    </div>
  )
};

export default NumberEntryView;
